export default {
    getDataPackageDetail: '/MedicalCollege/electronicData/package/detail', // 电子资料包详情 
    sendDataPackageToEmail: '/MedicalCollege/email/sendEmail', // 微网站 任务确认书-我的日程-资料包邮件发送
}